import * as React from "react";
const SvgStop = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 8, viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 8V0H8V8H0Z", fill: "#333333" }));
export default SvgStop;
